import { createSlice } from "@reduxjs/toolkit";

export const UsersSlice = createSlice({
  name: "users",
  initialState: {
    users: [],
  },
  reducers: {
    saveUsersData: (state, action) => {
      state.users = action.payload;
    }
  }
});

export const { saveUsersData } = UsersSlice.actions;
export default UsersSlice.reducer;